import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M4.39165876,12 L4.39165876,4 L7.1048678,4 L7.1048678,5.13923046 L5.89582377,5.13923046 L5.89582377,10.8607695 L7.1048678,10.8607695 L7.1048678,12 L4.39165876,12 Z M12.0838499,4 L12.0838499,12 L9.37064081,12 L9.37064081,10.8607695 L10.5796848,10.8607695 L10.5796848,5.13923046 L9.37064081,5.13923046 L9.37064081,4 L12.0838499,4 Z"/>
  </svg>
);
